import { Functions, httpsCallable } from 'firebase/functions';

export class FirebaseNovelSharing {
  constructor(private functions: Functions) {}

  async resolveUserByQuery(query: string): Promise<{ uid: string; email: string; displayName: string }> {
    const fn = httpsCallable<{ query: string }, { uid: string; email: string; displayName: string }>(
      this.functions,
      'resolveUserByQuery'
    );
    const res = await fn({ query });
    return res.data;
  }

  async sendEmailInvitation(params: {
    email: string;
    novelId: string;
    ownerId: string;
    role: 'collaborator' | 'reader';
    novelTitle: string;
  }): Promise<void> {
    const fn = httpsCallable<typeof params, { success: boolean; queued: boolean }>(
      this.functions,
      'sendEmailInvitation'
    );
    await fn(params);
  }

  async addNovelMember(params: {
    novelId: string;
    memberUid: string;
    role: 'collaborator' | 'reader';
  }): Promise<void> {
    const fn = httpsCallable<typeof params, { success: boolean }>(
      this.functions,
      'addNovelMember'
    );
    await fn(params);
  }

  async removeNovelMember(params: {
    ownerId: string;
    novelId: string;
    memberUid?: string;
    email?: string;
    role: 'collaborator' | 'reader';
  }): Promise<void> {
    const fn = httpsCallable<typeof params, { success: boolean }>(
      this.functions,
      'removeNovelMember'
    );
    await fn(params);
  }

  async getInvitationDetails(token: string): Promise<{
    novelTitle: string;
    role: string;
    ownerId: string;
  }> {
    const fn = httpsCallable<{ token: string }, { success: boolean; novelTitle: string; role: string; ownerId: string }>(
      this.functions,
      'getInvitationDetails'
    );
    const res = await fn({ token });
    return {
      novelTitle: res.data.novelTitle,
      role: res.data.role,
      ownerId: res.data.ownerId,
    };
  }

  async acceptInvitation(token: string): Promise<void> {
    const fn = httpsCallable<{ token: string }, { success: boolean }>(
      this.functions,
      'acceptInvitation'
    );
    await fn({ token });
  }

  async declineInvitation(token: string): Promise<void> {
    const fn = httpsCallable<{ token: string }, { success: boolean }>(
      this.functions,
      'declineInvitation'
    );
    await fn({ token });
  }
}
